<template>
  <div class="main-layout__list main-layout__list_mxh80">
    <template v-if="list">
      <div
        class="main-layout__item main-layout__item_hover main-layout__item_head main-layout__item_p12"
      >
        <div class="w-3 t-c foz-23">
          <p>#</p>
        </div>
        <div class="w-7">
          <p>Hergestellt in</p>
        </div>
        <div class="w-10">
          <p>{{ $t("listsHeader.author") }}</p>
        </div>
        <div class="w-10">
          <p>{{ $t("listsHeader.full_name") }}</p>
        </div>
        <div class="w-11">Telefon</div>
        <div class="w-11">E-mail</div>
        <div class="w-14">
          <p>Probleme</p>
        </div>
        <div class="w-14">
          <p>{{ $t("forms.comment") }}</p>
        </div>

        <div class="main-layout__item-actions">
          <p>{{ $t("listsHeader.actions") }}</p>
        </div>
      </div>

      <div
        class="main-layout__item main-layout__item_hover main-layout__item_mh"
        v-for="(item, index) in list"
        :key="item.id"
        :class="{
          'main-layout__item_new': item.is_done === false,
        }"
      >
        <div class="w-3 t-c">
          <p>{{ index + 1 }}</p>
        </div>

        <div class="w-7">
          <p>{{ convertDateWithTime(item.created_at) }}</p>
        </div>
        <div class="w-10">
          <span v-if="item.admin"
            >Admin: {{ item.admin.first_name }} {{ item.admin.last_name }}</span
          >
          <span v-if="item.master"
            >{{ item.master.first_name }} {{ item.master.last_name }}</span
          >
        </div>
        <div class="w-10">
          <span v-if="item.client"
            >{{ item.client.first_name }} {{ item.client.last_name }}</span
          >
          <span v-else>-</span>
        </div>

        <div class="w-11">
          <span v-if="item.client">{{ item.client.phone }}</span>
          <span v-else>-</span>
        </div>
        <div class="w-11">
          <span v-if="item.client">{{ item.client.email }}</span>
          <span v-else>-</span>
        </div>

        <div class="w-14">
          <div v-if="item.client_problems && item.client_problems.length > 0">
            <p
              v-for="(problem, index) in item.client_problems"
              :key="index"
              :class="{
                'mb-6': index + 1 !== item.client_problems.length,
              }"
            >
              {{ problem.name }}
            </p>
          </div>
          <!-- <p>{{ item.name }}</p> -->
        </div>
        <div class="w-14">
          <span>{{ item.comment }}</span>
        </div>

        <div class="main-layout__item-actions">
          <div>
            <svg
              @click="editProblemModal(item)"
              width="24px"
              height="24px"
              class="main-layout__item-icon"
            >
              <use xlink:href="/images/svg/symbols.svg#svg-user-message" />
            </svg>
          </div>
          <div>
            <svg
              @click="openDeleteModal(item.id)"
              width="24px"
              height="24px"
              class="main-layout__item-icon"
            >
              <use xlink:href="/images/svg/symbols.svg#svg-user-del" />
            </svg>
          </div>
        </div>
      </div>
    </template>

    <add-btn @onClick="openTodoModal" />

    <modal
      :show="isShowModal"
      :dark="true"
      :outside="false"
      @close="closeTodoModal"
    >
      <todo-modal :isUpdate="isUpdate" @close="closeTodoModal" @done="done" />
    </modal>

    <modal
      :show="isShowDeleteModal"
      :showBtn="false"
      :dark="true"
      :outside="false"
      @close="closeDeleteModal"
    >
      <delete-modal
        :title="$t('global.areUsure').toString()"
        @cancel="closeDeleteModal"
        @next="deleteConfirm"
      />
    </modal>
  </div>
</template>

<script>
import addBtn from '@/components/controls/addBtn'
import todoModal from '@/components/modals/todo/todoModal'
import date from '@/mixins/date'

import { mapGetters, mapMutations, mapActions } from 'vuex'

export default {
    name: 'todoList',
    mixins: [date],
    props: {
        clientId: {
            required: false,
        },
    },
    components: {
        addBtn,
        todoModal,
    },
    computed: {
        ...mapGetters({
            list: 'todo/list',
            isShowModal: 'todo/isShowModal',
            todo: 'todo/todo',
        }),
    },
    data() {
        return {
            isShowDeleteModal: false,
            deletedId: null,
            isUpdate: false,
        }
    },
    methods: {
        ...mapActions({
            remove: 'todo/remove',
            fetch: 'todo/fetch',
            add: 'todo/add',
            update: 'todo/update',
        }),
        ...mapMutations({
            setState: 'todo/setState',
        }),
        editProblemModal(item) {
            this.isUpdate = true
            this.setState({
                key: 'todo',
                data: {
                    comment: item.comment,
                    is_done: item.is_done,
                    id: item.id,
                },
            })
            this.toggleModal()
        },
        openTodoModal() {
            this.isUpdate = false
            this.setState({
                key: 'todo',
                data: {
                    client_id: null,
                    comment: '',
                    is_done: false,
                },
            })

            this.toggleModal()
        },
        toggleModal() {
            this.setState({
                key: 'isShowModal',
                data: true,
            })
        },
        closeTodoModal() {
            this.setState({
                key: 'isShowModal',
                data: false,
            })
        },
        async done() {
            let isOkey

            if (this.isUpdate) {
                isOkey = await this.update(this.todo)
            } else {
                isOkey = await this.add(this.todo)
            }

            if (!isOkey) return

            this.setState({
                key: 'isShowModal',
                data: false,
            })

            const params = {}

            if (this.clientId && this.clientId !== 'all') {
                params.client_id = this.clientId
            }
            console.log(params)
            await this.fetch(params)
        },
        closeDeleteModal() {
            this.isShowDeleteModal = false
        },
        async deleteConfirm() {
            await this.remove(this.deletedId)
            await this.fetch({})
            this.isShowDeleteModal = false
        },
        openDeleteModal(id) {
            this.deletedId = id
            this.isShowDeleteModal = true
        },
    },
}
</script>
